export default __webpack_public_path__ + "static/media/video.81429811.mp4";